// CreateDamagedStock.jsx
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Input,
  Label,
  Button,
  Badge,
} from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// ===== use the SAME APIs, but from ../import/ =====
import {
  UnitListView,
  Save_Damagedstock,
  _Get,
} from "../import/ApiEndPoint/ApiCalling";
import { Create_Warehouse_List } from "../import/ApiEndPoint/Api";

let GrandTotal = [];
let SelectedITems = [];
let SelectedSize = [];

const CreateDamagedStock = () => {
  const navigate = useNavigate();

  const [product, setProduct] = useState([
    {
      product: "",
      productId: "",
      Reason: "",
      Damaged_Percent: "",
      AvailaleQty: 0,
      transferQty: 1,
      price: "",
      totalprice: "",
      Size: "",
      unitType: "",
    },
  ]);

  const [WareHouselist, setWarehouseList] = useState([]);
  const [WareHouseone, setWareHouseone] = useState([]);
  const [ProductWTWList, setProductWTWList] = useState([]);
  const [UnitList, setUnitList] = useState([]);
  const [grandTotalAmt, setGrandTotalAmt] = useState(0);
  const [error, setError] = useState("");

  // ---- load warehouses & units
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    _Get(Create_Warehouse_List, userData?.database)
      .then((res) => {
        const value = res?.Warehouse || [];
        if (value.length) setWarehouseList(value);
      })
      .catch(() => {});
    UnitListView(userData?._id, userData?.database)
      .then((res) => {
        const customADD = {
          primaryUnit: "PIECES(Pcs)",
          secondaryUnit: "PIECES(Pcs) 1",
          unitQty: 1,
        };
        setUnitList([...(res?.Unit || []), customADD]);
      })
      .catch(() => {});
  }, []);

  // ---- warehouse selection (from where) -> build product list
  const onSelectWarehouse = (selectedList) => {
    setWareHouseone(selectedList);
    const selected = selectedList?.[0];
    const mapped =
      selected?.productItems
        ?.filter(Boolean)
        ?.map((ele) => {
          const p = ele?.productId;
          if (!p) return null;
          return {
            ...ele,
            _id: p?._id,
            Product_Title: p?.Product_Title,
            Product_MRP: p?.Product_MRP,
            discount: p?.discount,
            currentStock: ele?.currentStock ?? ele?.Size ?? 0,
          };
        })
        ?.filter(Boolean) || [];
    setProductWTWList(mapped);
  };
  const onRemoveWarehouse = (selectedList) => setWareHouseone(selectedList);

  // ---- select product
  const handleSelection = (selectedList, selectedItem, index) => {
    SelectedITems.push(selectedItem);
    setProduct((prev) => {
      const list = [...prev];
      const row = { ...list[index] };
      row.price = selectedItem?.Product_MRP || 0;
      row.productId = selectedItem?._id || selectedItem?.productId?._id;
      row.AvailaleQty = selectedItem?.currentStock ?? 0;
      row.totalprice = Number(row.price || 0) * Number(row.transferQty || 0);
      list[index] = row;

      // recompute GT
      const gt = list.reduce(
        (sum, r) => sum + Number(r.price || 0) * Number(r.transferQty || 0),
        0
      );
      setGrandTotalAmt(gt);
      return list;
    });
  };

  const handleRemoveSelected = (_selectedList, _selectedItem, index) => {
    SelectedITems.splice(index, 1);
    const myarr = product.map((ele, i) => {
      const p = SelectedITems[i]?.Product_MRP || 0;
      const ind = Number(ele?.transferQty || 0) * Number(p);
      GrandTotal[index] = ind;
      return ind;
    });
    const amt = (myarr.length ? myarr : [0]).reduce((a, b) => a + b, 0);
    setGrandTotalAmt(amt);
  };

  // ---- optional: select unit/size
  const handleSelectionUnit = (selectedList, selectedItem, index) => {
    SelectedSize.push(selectedItem);
    setProduct((prev) => {
      const list = [...prev];
      const row = { ...list[index] };
      row.Size = selectedItem?.unitQty || 1;
      row.unitType = selectedItem?.primaryUnit || "";
      list[index] = row;

      const totals = list.map((ele, i) => {
        const uq = SelectedSize[i]?.unitQty || 1;
        return (
          Number(ele?.transferQty || 0) * Number(ele?.price || 0) * Number(uq)
        );
      });
      const amt = totals.reduce((a, b) => a + b, 0);
      setGrandTotalAmt(amt);
      return list;
    });
  };
  const handleRemoveSelectedUnit = (_l, _it, index) => {
    SelectedSize.splice(index, 1);
    const totals = product.map((ele, i) => {
      const uq = SelectedSize[i]?.unitQty || 1;
      return Number(ele?.transferQty || 0) * Number(uq);
    });
    const amt = totals.reduce((a, b) => a + b, 0);
    setGrandTotalAmt(amt);
  };

  // ---- quantity / damage % / reason handlers + totals
  const handleProductChange = (e, index, available) => {
    const { name, value } = e.target;
    setProduct((prev) => {
      const list = [...prev];
      const row = { ...list[index] };

      if (name === "transferQty") {
        const ask = Number(value || 0);
        const avail = Number(available || 0);
        if (ask <= avail) {
          row.transferQty = ask;
        } else {
          swal("Cannot transfer more than stock");
          row.transferQty = Math.max(avail - 1, 0);
        }
      } else if (name === "Damaged_Percent") {
        row.Damaged_Percent = value;
      } else if (name === "Reason") {
        row.Reason = value;
      }

      row.totalprice = Number(row.price || 0) * Number(row.transferQty || 0);
      list[index] = row;

      const totals = list.map(
        (r) => Number(r.price || 0) * Number(r.transferQty || 0)
      );
      const amt = totals.reduce((a, b) => a + b, 0);
      setGrandTotalAmt(amt);
      return list;
    });
  };

  // ---- add/remove product rows
  const addMoreProduct = () => {
    setProduct((prev) => [
      ...prev,
      {
        product: "",
        productId: "",
        Reason: "",
        Damaged_Percent: "",
        AvailaleQty: 0,
        transferQty: 1,
        price: "",
        totalprice: "",
        Size: "",
        unitType: "",
      },
    ]);
  };
  const removeMoreProduct = (i) => {
    setProduct((prev) => {
      const list = [...prev];
      list.splice(i, 1);
      GrandTotal.splice(i, 1);
      const amt = GrandTotal.reduce((a, b) => a + b, 0);
      setGrandTotalAmt(isFinite(amt) ? amt : 0);
      return list;
    });
  };

  // ---- submit damaged stock
  const DamagedStockSubmitHandler = async (e) => {
    e.preventDefault();
    const wh = WareHouseone?.[0]?._id;
    if (!wh)
      return swal("Select Warehouse", "Please choose a warehouse.", "warning");

    const p = product?.[0];
    if (!p?.productId)
      return swal("Select Product", "Please choose a product.", "warning");

    const payload = {
      typeStatus: "Damaged",
      warehouse: wh,
      productId: p.productId,
      damagePercentage: Number(p.Damaged_Percent || 0),
      reason: p.Reason || "",
      Size: p.Size || 1,
      unitType: p.unitType || "PIECES(Pcs)",
      transferQty: Number(p.transferQty || 0),
      price: Number(p.price || 0),
      totalPrice: Number(p.transferQty || 0) * Number(p.price || 0),
      currentStock: Number(p.AvailaleQty || 0) - Number(p.transferQty || 0),
    };

    try {
      await Save_Damagedstock(payload);
      swal("Success", "Damaged stock created.", "success");
      navigate(-1);
    } catch (err) {
      console.error(err);
      swal("Something Went Wrong", err?.response?.data?.message || "", "error");
    }
  };

  return (
    <div>
      <Card>
        <Row className="m-2">
          <Col lg="8" md="8" sm="8" className="mb-2 mt-1">
            <h1 className="">Add Stock to Damage</h1>
          </Col>
        </Row>

        <CardBody>
          <Form className="mx-1" onSubmit={DamagedStockSubmitHandler}>
            <Row>
              <Col className="mb-1" lg="3" md="3" sm="12">
                <Label>Choose Warehouse (from where) *</Label>
                <Multiselect
                  required
                  selectionLimit={1}
                  isObject
                  options={WareHouselist}
                  onSelect={onSelectWarehouse}
                  onRemove={onRemoveWarehouse}
                  displayValue="warehouseName"
                />
              </Col>
            </Row>

            {product.map((row, index) => (
              <Row key={index}>
                <Col className="mb-1" lg="3" md="3" sm="12">
                  <Label>Product Name</Label>
                  <Multiselect
                    required
                    selectionLimit={1}
                    isObject
                    options={ProductWTWList}
                    onSelect={(list, item) =>
                      handleSelection(list, item, index)
                    }
                    onRemove={(list, item) =>
                      handleRemoveSelected(list, item, index)
                    }
                    displayValue="Product_Title"
                  />
                </Col>

                <Col className="mb-1" lg="2" md="2" sm="12">
                  <Label>Available Qty</Label>
                  <Input
                    disabled
                    type="number"
                    name="AvailaleQty"
                    value={row.AvailaleQty || 0}
                  />
                </Col>

                <Col className="mb-1" lg="2" md="2" sm="12">
                  <Label>Damage %</Label>
                  <Input
                    type="number"
                    name="Damaged_Percent"
                    min={0}
                    max={100}
                    value={row.Damaged_Percent}
                    onChange={(e) =>
                      handleProductChange(e, index, row.AvailaleQty)
                    }
                  />
                </Col>

                <Col className="mb-1" lg="2" md="2" sm="12">
                  <Label>Damage Qty</Label>
                  <Input
                    type="number"
                    min={0}
                    name="transferQty"
                    value={row.transferQty}
                    onChange={(e) =>
                      handleProductChange(e, index, row.AvailaleQty)
                    }
                  />
                </Col>

                <Col className="mb-1" lg="3" md="3" sm="12">
                  <Label>Reason</Label>
                  <Input
                    type="text"
                    name="Reason"
                    value={row.Reason}
                    onChange={(e) =>
                      handleProductChange(e, index, row.AvailaleQty)
                    }
                  />
                </Col>

                <Col className="mb-1" lg="2" md="2" sm="12">
                  <Label>Unit</Label>
                  <Multiselect
                    selectionLimit={1}
                    isObject
                    options={UnitList}
                    onSelect={(l, it) => handleSelectionUnit(l, it, index)}
                    onRemove={(l, it) => handleRemoveSelectedUnit(l, it, index)}
                    displayValue="primaryUnit"
                  />
                </Col>

                <Col className="mb-1" lg="2" md="2" sm="12">
                  <Label>Price</Label>
                  <Input
                    type="number"
                    name="price"
                    readOnly
                    value={row.price || ""}
                  />
                </Col>

                <Col className="mb-1" lg="2" md="2" sm="12">
                  <Label>Total Price</Label>
                  <Input
                    type="number"
                    name="totalprice"
                    readOnly
                    value={
                      Number(row.price || 0) * Number(row.transferQty || 0)
                    }
                  />
                </Col>

                <Col className="d-flex mt-1" lg="3" md="3" sm="12">
                  {index > 0 && (
                    <Badge
                      type="button"
                      color="danger"
                      className="button remove"
                      onClick={() => removeMoreProduct(index)}
                    >
                      - Remove
                    </Badge>
                  )}
                  <Badge
                    className="ml-1 mb-1"
                    color="primary"
                    type="button"
                    onClick={addMoreProduct}
                    style={{ marginLeft: 8 }}
                  >
                    + Add
                  </Badge>
                </Col>
              </Row>
            ))}

            <Row>
              <Col className="mb-1" lg="12" md="12" sm="12">
                <div className="d-flex justify-content-end">
                  <Label className="pr-5">
                    Grand Total :{" "}
                    <strong>{isNaN(grandTotalAmt) ? 0 : grandTotalAmt}</strong>
                  </Label>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg="5" />
              <Col lg="1">
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </Col>
              <Col lg="1">
                <Button color="secondary" onClick={() => navigate(-1)}>
                  Back
                </Button>
              </Col>
              <Col lg="5" />
            </Row>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default CreateDamagedStock;
